import React from 'react';
import { FaBook, FaPrint, FaBookOpen, FaChartBar, FaCalendarAlt, FaMoneyBillWave } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaBook />,
  2: <FaPrint />,
  3: <FaBookOpen />,
  4: <FaChartBar />,
  5: <FaCalendarAlt />,
  6: <FaMoneyBillWave />
};

const PublishingIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="publishing"
      gradient="#2c3e50 0%, #3498db 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default PublishingIndustryPage;

